import { createBrowserHistory } from 'history';
const historyService = createBrowserHistory();
export default historyService;
